module.exports = __webpack_public_path__ + "img/ic_edit.3a597a1b.svg";